import { GA4EventName, GA4FeatureCategory, trackAnalyticsEvent } from '@jsmdg/tracking';

async function trackVoucherCountSelection(productTitle: string, diff: number): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        eventData: {
            eventName: diff > 0 ? GA4EventName.IncreaseCount : GA4EventName.DecreaseCount,
            feature_category: GA4FeatureCategory.ProductdetailBuybox,
            product_count_changed: diff,
            product_title: productTitle,
        },
    });
}

export { trackVoucherCountSelection };
